import { FormEvent } from "react";
import { TranslationKey } from "../../../shared/i18n/i18n";

type SignInFormProps = {
  email: string;
  isSubmitting: boolean;
  onEmailChange: (value: string) => void;
  onOpenForgotPassword: () => void;
  onOpenSignUp: () => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
  password: string;
  t: (key: TranslationKey) => string;
};

export const SignInForm = ({
  email,
  isSubmitting,
  onEmailChange,
  onOpenForgotPassword,
  onOpenSignUp,
  onPasswordChange,
  onSubmit,
  password,
  t,
}: SignInFormProps) => {
  return (
    <form
      className="auth-form"
      onSubmit={(event) => void onSubmit(event)}
    >
      <p className="admin-subtitle">{t("admin.auth.subtitle")}</p>
      <label className="field">
        <span>{t("admin.field.email")}</span>
        <input
          onChange={(event) => onEmailChange(event.target.value)}
          required
          type="email"
          value={email}
        />
      </label>
      <label className="field">
        <span>{t("admin.field.password")}</span>
        <input
          onChange={(event) => onPasswordChange(event.target.value)}
          required
          type="password"
          value={password}
        />
      </label>
      <button
        className="link-button form-help-link"
        onClick={onOpenForgotPassword}
        type="button"
      >
        {t("admin.link.forgotPassword")}
      </button>
      <button
        className="primary-button"
        disabled={isSubmitting}
        type="submit"
      >
        {isSubmitting ? t("admin.button.signingIn") : t("admin.button.signIn")}
      </button>
      <p className="switch-line">
        {t("admin.auth.switch.noAccount")}{" "}
        <button
          className="link-button inline-link"
          onClick={onOpenSignUp}
          type="button"
        >
          {t("admin.mode.signUp")}
        </button>
      </p>
    </form>
  );
};
